import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
import authentication from "@irati/auth";
var endpoints = {
    create: function () { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/accounts"); },
    getMedicalAccount: function () { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/accounts/user/" + authentication.user().uuid); },
    textMeInstructions: function () { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/sms"); },
    getStats: function () { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/activation/tenant/" + authentication.userTenant().uuid + "/stats"); },
    getCsv: function (tenantId) { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/activation/tenant/" + tenantId + "/csv"); },
    resendWelcomeEmail: function () { return getUrlForEnv(services.MEDICAL_SERVICE, "/v1/resend-welcome-email"); }
};
export default endpoints;
